



// import React, { useEffect, useState } from "react";
// import { getDecryptedAccessToken, getDecryptedData, getDecryptedUserType } from "../../../Utils/LoginUserDetails.js/LoginUserSavedDetails";
// import ApiServices from "../../../Utils/ApiServices/ApiServices";
// import { Card, CardContent, Typography, Box } from "@mui/material";
// import Slider from "react-slick";
// import "slick-carousel/slick/slick.css";
// import "slick-carousel/slick/slick-theme.css";
// import { ArrowBackIos, ArrowForwardIos, Event, AccessTime } from "@mui/icons-material";

// const statusMapping = {
//   "^": "Pending",
//   APPR: "Approved",
//   REJ: "Rejected",
// };

// // Custom Arrows for navigation
// const PrevArrow = (props) => {
//   const { className, onClick } = props;
//   return (
//     <ArrowBackIos 
//       className={className} 
//       onClick={onClick} 
//       style={{ color: "#028391", fontSize: 24, left: "-30px", zIndex: 1 }} 
//     />
//   );
// };

// const NextArrow = (props) => {
//   const { className, onClick } = props;
//   return (
//     <ArrowForwardIos 
//       className={className} 
//       onClick={onClick} 
//       style={{ color: "#028391", fontSize: 24, right: "-30px", zIndex: 1 }} 
//     />
//   );
// };

// const AllAppointments = ({ patientData }) => {
//   const [appointments, setAppointments] = useState([]);
//   const LoginUserDetails = getDecryptedData();
//   const LoginUserType = getDecryptedUserType();
//   const accessToken = getDecryptedAccessToken();
//   const pid = LoginUserType === "Patient" ? LoginUserDetails?.pid : patientData?.pid;

//   useEffect(() => {
//     if (!pid) return;

//     const fetchAppointments = async () => {
//       const endpoint = LoginUserType === "Patient"
//         ? `/apis/default/portal/patient/${pid}/appointment`
//         : `/apis/default/api/patient/${pid}/appointment`;

//       try {
//         const response = await ApiServices.get(endpoint, {
//           Authorization: `Bearer ${accessToken}`,
//         });

//         const currentDate = new Date().toISOString().split("T")[0];

//         const sortedAppointments = response.data
//           .filter((appt) => appt.pc_eventDate >= currentDate) // Filter future & today's appointments
//           .sort((a, b) => new Date(a.pc_eventDate) - new Date(b.pc_eventDate)); // Sort by date ascending

//         setAppointments(sortedAppointments);
//       } catch (error) {
//         console.error("Error fetching appointments:", error);
//       }
//     };

//     fetchAppointments();
//   }, [pid, LoginUserType]);

//   const settings = {
//     dots: false,
//     infinite: false,
//     speed: 500,
//     slidesToShow: 4,
//     slidesToScroll: 1,
//     prevArrow: <PrevArrow />,
//     nextArrow: <NextArrow />,
//     responsive: [
//       { breakpoint: 1200, settings: { slidesToShow: 3 } },
//       { breakpoint: 900, settings: { slidesToShow: 2 } },
//       { breakpoint: 600, settings: { slidesToShow: 1, centerMode: true, centerPadding: "10px" } } // Prevents cards from going out of screen
//     ]
//   };
  

//   return (
//     <Box sx={{ maxWidth: "90%", mx: "auto", mt: 3 }}>
//       {appointments.length > 0 ? (
//         <Slider {...settings}>
//           {appointments.map((appointment) => {
//             const isToday = new Date().toISOString().split("T")[0] === appointment.pc_eventDate;

//             return (
//               <Card
//   key={appointment.pc_eid}
//   sx={{
//     mx: 1,
//     mr: 2, // Adds space between cards
//     boxShadow: 3,
//     border: `2px solid #028391`,
//     backgroundColor: isToday ? "#E0F7FA" : "white",
//     minWidth: 280, // Ensures responsiveness
//   }}
// >

//                 <CardContent>
//                   <Typography variant="h6" sx={{ fontWeight: "bold", color: "#028391" }}>
//                     {appointment.appointment_type}
//                   </Typography>
//                   <Typography variant="body2" sx={{ color: "gray", fontSize: "12px" }}>
//                     ID: {appointment.pc_eid}
//                   </Typography>

//                   <Box display="flex" alignItems="center" mt={1}>
//                     <Event sx={{ color: "#028391", mr: 1 }} />
//                     <Typography variant="body1">{appointment.pc_eventDate}</Typography>
//                   </Box>

//                   <Box display="flex" alignItems="center" mt={1}>
//                     <AccessTime sx={{ color: "#028391", mr: 1 }} />
//                     <Typography variant="body1">{appointment.pc_startTime}</Typography>
//                   </Box>

//                   <Typography
//                     variant="body1"
//                     sx={{
//                       fontWeight: "bold",
//                       color: appointment.pc_apptstatus === "APPR" ? "green" :
//                             appointment.pc_apptstatus === "REJ" ? "red" : "orange"
//                     }}
//                   >
//                     Status: {statusMapping[appointment.pc_apptstatus] || "Unknown"}
//                   </Typography>
//                 </CardContent>
//               </Card>
//             );
//           })}
//         </Slider>
//       ) : (
//         <Typography variant="body1" align="center" sx={{ color: "gray", mt: 2 }}>
//           No upcoming appointments.
//         </Typography>
//       )}
//     </Box>
//   );
// };

// export default AllAppointments;



import React, { useEffect, useState } from "react";
import { getDecryptedAccessToken, getDecryptedData, getDecryptedUserType } from "../../../Utils/LoginUserDetails.js/LoginUserSavedDetails";
import ApiServices from "../../../Utils/ApiServices/ApiServices";
import { Card, CardContent, Typography, Box } from "@mui/material";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { ArrowBackIos, ArrowForwardIos, Event, AccessTime } from "@mui/icons-material";
import { useNavigate, useParams } from "react-router-dom";

const statusMapping = {
  "^": "Pending",
  APPR: "Approved",
  REJ: "Rejected",
};

// Custom Arrows for navigation
const PrevArrow = (props) => {
  const { className, onClick } = props;
  return (
    <ArrowBackIos
      className={className}
      onClick={onClick}
      style={{ color: "#028391", fontSize: 24, left: "-30px", zIndex: 1 }}
    />
  );
};

const NextArrow = (props) => {
  const { className, onClick } = props;
  return (
    <ArrowForwardIos
      className={className}
      onClick={onClick}
      style={{ color: "#028391", fontSize: 24, right: "-30px", zIndex: 1 }}
    />
  );
};

const AllAppointments = ({ patientData }) => {
  const [appointments, setAppointments] = useState([]);
  const LoginUserDetails = getDecryptedData();
  const LoginUserType = getDecryptedUserType();
  const accessToken = getDecryptedAccessToken();
  const params = useParams()

  const pid = LoginUserType === "Patient" ? LoginUserDetails?.pid : params?.pid;
const navigate = useNavigate()
  useEffect(() => {
    if (!pid) return;

    const fetchAppointments = async () => {
      const endpoint =
        LoginUserType === "Patient"
          ? `/apis/default/portal/patient/${pid}/appointment`
          : `/apis/default/api/patient/${pid}/appointment`;

      try {
        const response = await ApiServices.get(endpoint, {
          Authorization: `Bearer ${accessToken}`,
        });

        const currentDate = new Date().toISOString().split("T")[0];

        const sortedAppointments = response.data
          .filter((appt) => appt.pc_eventDate >= currentDate) // Filter future & today's appointments
          .sort((a, b) => new Date(a.pc_eventDate) - new Date(b.pc_eventDate)); // Sort by date ascending

        setAppointments(sortedAppointments);
      } catch (error) {
        console.error("Error fetching appointments:", error);
      }
    };

    fetchAppointments();
  }, [params.pid,pid, LoginUserType]);

  const settings = {
    dots: false,
    infinite: false, // Prevents last card from going out of screen
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    prevArrow: <PrevArrow />,
    nextArrow: <NextArrow />,
    responsive: [
      { breakpoint: 1400, settings: { slidesToShow: 3 } },
      { breakpoint: 1024, settings: { slidesToShow: 2 } },
      { breakpoint: 768, settings: { slidesToShow: 1, centerMode: true, centerPadding: "20px" } }
    ]
  };

  return (
    <Box sx={{ maxWidth: "95%", mx: "auto", mt: 3 }}>
      {appointments.length > 0 ? (
       <>
       <Box display="flex" justifyContent="space-between" alignItems="center" sx={{ mb: 2 }}>
  <Typography variant="h5" fontWeight="bold" sx={{ color: "#028391" }}>
    Upcoming Appointments
  </Typography>
  <Typography
    variant="body1"
    sx={{ color: "#028391", cursor: "pointer", textDecoration: "underline" }}
    onClick={() => {
      const route = LoginUserType === "Patient" ? "/patient/appointments" : "/provider/appointments";
      navigate(route); // Navigate user using React Router
    }}
  >
    Show All
  </Typography>
</Box>

        <Slider {...settings}>
          {appointments.map((appointment) => {
            const isToday = new Date().toISOString().split("T")[0] === appointment.pc_eventDate;

            return (
              <Box key={appointment.pc_eid} sx={{ px: { xs: 1, md: 2 } }}>
                <Card
                  sx={{
                    boxShadow: 3,
                    borderRadius: 3, 
                    border: `2px solid #028391`,
                    backgroundColor: isToday ? "#E0F7FA" : "white",
                    minWidth: { xs: "90%", sm: "280px" }, // Ensures responsiveness
                    maxWidth: "100%",
                  }}
                >
                  <CardContent>
                    <Typography
                      variant="h6"
                      sx={{
                        fontWeight: "bold",
                        color: "#028391",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        maxWidth: "100%", 
                        whiteSpace: { xs: "normal", md: "nowrap" }, // Break text on small screens
                        fontSize: appointment.appointment_type.length > 20 ? "14px" : "16px", // Adjust size dynamically
                      }}
                    >
                      {appointment.appointment_type}
                    </Typography>
                    <Typography variant="body2" sx={{ color: "gray", fontSize: "12px" }}>
                      ID: {appointment.pc_eid}
                    </Typography>

                    <Box display="flex" alignItems="center" mt={1}>
                      <Event sx={{ color: "#028391", mr: 1 }} />
                      <Typography variant="body1">{appointment.pc_eventDate}</Typography>
                    </Box>

                    <Box display="flex" alignItems="center" mt={1}>
                      <AccessTime sx={{ color: "#028391", mr: 1 }} />
                      <Typography variant="body1">{appointment.pc_startTime}</Typography>
                    </Box>

                    <Typography
                      variant="body1"
                      sx={{
                        fontWeight: "bold",
                        color:
                          appointment.pc_apptstatus === "APPR"
                            ? "green"
                            : appointment.pc_apptstatus === "REJ"
                            ? "red"
                            : "orange",
                      }}
                    >
                      Status: {statusMapping[appointment.pc_apptstatus] || "Unknown"}
                    </Typography>
                  </CardContent>
                </Card>
              </Box>
            );
          })}
        </Slider>
        </>
      ) : (
        <Box display="flex" justifyContent="space-between" alignItems="center" sx={{ mb: 2 }}>
  <Typography variant="h5" fontWeight="bold" sx={{ color: "#028391" }}>
   No Upcoming Appointments
  </Typography>
  <Typography
    variant="body1"
    sx={{ color: "#028391", cursor: "pointer", textDecoration: "underline" }}
    onClick={() => {
      const route = LoginUserType === "Patient" ? "/patient/appointments" : "/provider/appointments";
      navigate(route); // Navigate user using React Router
    }}
  >
    Show Previous
  </Typography>
</Box>
      )}
    </Box>
  );
};

export default AllAppointments;
